// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__OGZPC","icon":"styles_icon__dhmnK","text":"styles_text__uuueV","subtext":"styles_subtext__JA70O"};